const WP_UPLOADS_PATH = 'https://www.originenergy.com.au/wp-content/uploads';

/** States for which Origin publishes standard retail contract terms PDFs. */
export type StandingRetailTermsState = 'ACT' | 'NSW' | 'VIC' | 'QLD' | 'SA' | 'WA';

/**
 * Per-state PDF URLs for Origin's standard retail contract terms and conditions.
 * Applies to any standing-offer plan (Solar Sharer included).
 */
export const STANDING_RETAIL_TERMS_URL_BY_STATE: Record<StandingRetailTermsState, string> = {
  ACT: `${WP_UPLOADS_PATH}/121/6713v15.Jun25.ACT_.OE-Standard-Terms-and-Conditions-WEB-FA01.pdf`,
  NSW: `${WP_UPLOADS_PATH}/290/1659v21.Jun25.NSW_.OE-Standard-Terms-and-Conditions-WEB-FA01.pdf`,
  VIC: `${WP_UPLOADS_PATH}/terms-and-conditions-standard-vic-v15.pdf`,
  QLD: `${WP_UPLOADS_PATH}/201/8665v13.Jun25.QLD_.OE-Standard-Terms-Conditions-WEB-FA01.pdf`,
  SA: `${WP_UPLOADS_PATH}/286/1657v17.Jun25.SA_.OE-Standard-Terms-and-Conditions-WEB-FA01-1.pdf`,
  WA: `${WP_UPLOADS_PATH}/297/standard-terms-and-conditions-v5.pdf`,
};
